import React, { Component } from 'react';
import '../../../src/styles/ShoppingCart.css';
import '../../../src/styles/open-iconic.css';
import '../../../src/styles/open-iconic-bootstrap.css';
import { appService } from '../../_services';
import { userService } from '../../_services';
import DocumentMeta from 'react-document-meta';
import { Redirect, Route } from 'react-router-dom';

export class ChangeETOCAccount extends Component {
    displayName = ChangeETOCAccount.name

    constructor(props) {
        super(props);
        this.childList = React.createRef();
        this.state = {
            userDetails: {
                salutation: '',
                firstName: '',
                lastName: '',
                emailAddress: '',
                phoneNumber: '',
                organization: '',
                jobTitle: '',
                iAgree: false,
                country: '',
                subType: '',
                addInfo: '',
                redirectToThankyou: false
            },
            errors: {},
            submitted: false,
            email: '',
            valid: true,
            content: '',
            users: [],
            countries: [],
            data: [],
            selectedString: '', practicearea: '', selectedOption: ''
        };
    }
    componentDidMount() {
    }


    render() {
     
        return (
            <DocumentMeta>
                <div className="col-12 klo-shopping-cart">
                    <div className="row">
                        <div className="col-lg-12 colPadding margintop">
                            <div className="mt-4 font-500">
                                <p className="franziskafont">Change Email address</p>
                                
                                <div className="row">
                                    <div className="col mr-4">
                                       
                                        <div className="form-row mt-3">
                                            <div className="col-lg-6">
                                                <label for="firstName">Current Email address</label>
                                                <input type="text" className="form-control form-control-sm rounded-0" id="firstName" name="firstName" onChange={this.valueChange} />
                                                <div className="errorMsg">{this.state.errors.firstName}</div>
                                            </div>
                                          
                                           
                                        </div>
                                        <br></br>
                                        <div className="form-row mt-3">
                                            <div className="col-lg-6">
                                                <label for="lastName">New Email address</label>
                                                <input type="text" className="form-control form-control-sm rounded-0" id="lastName" name="lastName" onChange={this.valueChange} />
                                                <div className="errorMsg">{this.state.errors.lastName}</div>
                                            </div>
                                              
                                        </div>
                                        <br></br>
                                        <div className="form-row mt-3">
                                            <div className="col-lg-6">
                                                <label for="lastName">Password</label>
                                                <input type="text" className="form-control form-control-sm rounded-0" id="lastName" name="lastName"  onChange={this.valueChange} />
                                                <div className="errorMsg">{this.state.errors.lastName}</div>
                                            </div>
                                           
                                        </div>
                                        <br></br>
                                       
                                       
                                    </div>

                                    <div className="col ml-3"> </div>
                                </div>
                                <div className="row mb-5 mt-3 ">
                                    <div className="col">
                                        <button type="button" className="btn next float-left rounded-0" >Change Email address</button>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-lg-12 colPadding">
                            <div className="mt-4 font-500">
                                <p className="franziskafont">Change Password</p>

                                <div className="row">
                                    <div className="col mr-4">

                                        <div className="form-row mt-3">
                                            <div className="col-lg-6">
                                                <label for="firstName">Current Password</label>
                                                <input type="text" className="form-control form-control-sm rounded-0" id="firstName" name="firstName" onChange={this.valueChange} />
                                                <div className="errorMsg">{this.state.errors.firstName}</div>
                                            </div>


                                        </div>
                                        <br></br>
                                        <div className="form-row mt-3">
                                            <div className="col-lg-6">
                                                <label for="lastName">New Password</label>
                                                <input type="text" className="form-control form-control-sm rounded-0" id="lastName" name="lastName" onChange={this.valueChange} />
                                                <div className="errorMsg">{this.state.errors.lastName}</div>
                                            </div>

                                        </div>
                                        <br></br>
                                        <div className="form-row mt-3">
                                            <div className="col-lg-6">
                                                <label for="lastName">Confirm Password</label>
                                                <input type="text" className="form-control form-control-sm rounded-0" id="lastName" name="lastName" onChange={this.valueChange} />
                                                <div className="errorMsg">{this.state.errors.lastName}</div>
                                            </div>

                                        </div>
                                        <br></br>


                                    </div>

                                    <div className="col ml-3"> </div>
                                </div>
                                <div className="row mb-5 mt-3 ">
                                    <div className="col">
                                        <button type="button" className="btn next float-left rounded-0" >Change Password</button>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </DocumentMeta>

        );
    }
}



// WEBPACK FOOTER //
// ./src/components/ETOC Accounts/ChangeETOCAccount.jsx